import { LD12Chart } from "store/slice/charts/chartsSlice.types";
import { TCustomiseLabelsOptions } from "../CustomiseLabels/CustomiseLabels.config";

export const getOptions = ({
    chartData,
    handleDrawChart,
    handleLegendItemClick,
    hideLegend,
    shouldShowExportingMenu,
    customiseLabels,
}: {
    chartData: LD12Chart;
    handleDrawChart: (
        chart: Highcharts.Chart,
        isExporting: boolean,
        isRedrawing: boolean,
        customiseLabels: TCustomiseLabelsOptions,
        newChartData?: LD12Chart
    ) => void;
    handleLegendItemClick: (serie: Highcharts.Series) => void;
    hideLegend: boolean;
    shouldShowExportingMenu: boolean;
    customiseLabels: TCustomiseLabelsOptions;
}): Highcharts.Options => {
    return {
        chart: {
            spacing: [0, 0, 0, 0],
            margin: [0, 0, 0, 0],
            animation: false,
            className: "BehaviouralBreakdownChart",
            events: {
                load: function () {
                    handleDrawChart(this, false, false, customiseLabels);
                },
                redraw: function () {
                    handleDrawChart(this, false, true, customiseLabels);
                },
            },
            style: {
                fontFamily: "Lato, sans-serif",
            },
        },
        credits: {
            text: "",
        },
        title: {
            text: undefined,
        },
        exporting: {
            enabled: shouldShowExportingMenu,
            menuItemDefinitions: {
                downloadPNG: { text: "Download PNG Image" },
                downloadSVG: { text: "Download SVG Image" },
            },
            buttons: {
                contextButton: {
                    menuItems: ["downloadPNG", "downloadSVG"],
                },
            },
            chartOptions: {
                chart: {
                    events: {
                        load: function () {
                            if (this.plotHeight < 460) {
                                this.setSize(null, 460, false);
                            }
                            this.setSize(null, null, false);
                            handleDrawChart(this, true, false, customiseLabels);
                        },
                    },
                },
            },
        },
        yAxis: {
            lineWidth: 0,
            tickInterval: 10,
            gridLineWidth: 0,
            gridLineColor: "transparent",
        },
        xAxis: {
            lineWidth: 0,
            gridLineWidth: 0,
            gridLineColor: "transparent",
        },
        tooltip: {
            enabled: false,
        },
        plotOptions: {
            series: {
                lineWidth: 0,
                color: "transparent",
                marker: {
                    lineColor: "transparent",
                    radius: 0,
                    states: {
                        hover: {
                            enabled: false,
                        },
                    },
                },
                states: {
                    hover: {
                        halo: null,
                    },
                },
                events: {
                    legendItemClick: function () {
                        handleLegendItemClick(this);
                    },
                },
            },
        },
        legend: {
            enabled: !hideLegend,
            align: "center", // Center the legend horizontally
            verticalAlign: "bottom", // Position it at the bottom
            itemStyle: {
                fontWeight: "600",
            },
        },
        series: chartData?.series_labels.map((serie, i) => {
            const { id, label, ...otherProps } = serie;

            return {
                ...otherProps,
                type: "scatter",
                name: serie.entity_name ?? "",
                showInLegend: serie.enabled,
                className: !serie.enabled ? "disabled-element" : "",
                visible: serie.visible,
                marker: {
                    symbol: "circle",
                    radius: 8,
                },
            };
        }),
    };
};
